import { connect } from "react-redux";
import moment from "moment";
import React, { Fragment, useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import 'react-datepicker/dist/react-datepicker.css';
import { Row, Col, Button, Label, Input, FormGroup, Spinner } from "reactstrap";
import { RotateSpinner } from 'react-spinners-kit';
import { Colxx } from "../../../../../components/common/CustomBootstrap";
import { postAPI_Voucher_Statement, gAPI_Internal_Property_By_Id, API_Ingetration, postAPI_Voucher_Send_Statement } from "../../../../../constants/APIs";
import { AxiosAPI, getGroupID } from "../../../../../helpers/AxiosAPI";
import { NotificationManager } from "../../../../../components/common/react-notifications";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { CSVLink } from "react-csv";
import DatePicker from 'react-datepicker';
let headers = [
    { label: "Voucher Name", key: "voucherName" },
    { label: "Voucher Owner", key: "ownerName" },
    { label: "Selling Partner", key: "sellingPartyName" },
    { label: "Order Number", key: "orderNumber" },
    { label: "Voucher Number", key: "voucherNumber" },
    { label: "Customer", key: "email" },
    { label: "Voucher Status", key: "voucherStatus" },
    { label: "Voucher Sale Date", key: "orderDate" },
    { label: "Sales Amount", key: "discountedPrice" },
    { label: "aiva Commission", key: "aiva" },
    { label: "3rd party commission", key: "3rdParty" },
    { label: "Settlement Date", key: "settlementDate" },
    { label: "Net Amount", key: "transferedAmount" }
];
function Statement({ propertyId }) {
    const [statement, setStatement] = useState([]);
    const [integrations, setIntegrations] = useState('');
    const [property, setProperty] = useState('');
    const [startDate, setStartDate] = useState(moment().subtract('8', 'days'));
    const [endDate, setEndDate] = useState(moment().subtract('1', 'days'));
    const [isLoading, setIsLoading] = useState(false);
    const [csvData, setCSVData] = useState([{
        "voucherName": '',
        "ownerName": '',
        "sellingPartyName": '',
        "orderNumber": '',
        "voucherNumber": '',
        "email": '',
        "orderDate": '',
        "discountedPrice": '',
        "aiva": '',
        "3rdParty": '',
        "settlementDate": '',
        "transferedAmount": '',
    }]);

    const csvReport = {
        data: csvData,
        headers: headers,
        filename: 'Voucher' + 'Statement.csv'
    };

    useEffect(() => {
        AxiosAPI({
            methhod: 'get',
            url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${getGroupID()}`,
        })
            .then((res) => {
                setProperty(res.data);
            });
            let body={
                'channels':['Stripe']
            };
            AxiosAPI({
                method: 'post',
                url: `${API_Ingetration}?group_id=${getGroupID()}`,
                data: body
              }).then((res) => {

            const stripeIntregationData = res.data.filter(
                (k) => k.channel === 'Stripe' && k.properties.includes(propertyId)
            );
            setIntegrations(stripeIntregationData);

        });

    }, propertyId);

    const handleSubmit = () => {
        let fromDate = startDate ? startDate.format('YYYY-MM-DD') + ' 00:00:00' : '';
        let toDate = endDate ? endDate.format('YYYY-MM-DD') + ' 23:59:59' : '';
        setStatement([]);
        setIsLoading(true);
        let data = {
            'groupId': getGroupID(),
            'propertyId': propertyId,
            'startDate': fromDate,
            'endDate': toDate
        }
        AxiosAPI({
            method: 'post',
            url: `${postAPI_Voucher_Statement}`,
            data,
        })
            .then((res) => {
               
                if (res.data.statementList !== undefined && res.data.statementList.length > 0) {
                    let values = [];                 
                    res.data.statementList.map((s) => {                        
                        values.push({
                            "voucherName": s.voucherName,
                            "ownerName": s.ownerName,
                            "sellingPartyName": s.sellingPartyName,
                            "orderNumber": s.orderNumber,
                            "voucherNumber": s.voucherNumber,
                            "voucherStatus":s.voucherStatus,
                            "email": s.email,
                            "orderDate": moment(s.orderDate).format('YYYY-MM-DD'),
                            "discountedPrice": '$' + s.discountedPrice,
                            "aiva": parseFloat((s.aivaFee * 100) / s.discountedPrice).toFixed(2) + '%',
                            "3rdParty": parseFloat((s.thirdPartyFee * 100) / s.discountedPrice).toFixed(2) + '%',
                            "settlementDate": '',
                            "transferedAmount": '$' + s.transferedAmount,
                        });
                    });
                  setCSVData(values);
                  setStatement(res.data);
                }
            }).catch((res) => null);
    }
    const handleDownload = () => {
        
        let fromDate = startDate ? startDate.format('YYYY-MM-DD') + ' 00:00:00' : '';
        let toDate = endDate ? endDate.format('YYYY-MM-DD') + ' 23:59:59' : '';

        let data = {
            'groupId': getGroupID(),
            'propertyId': propertyId,
            'startDate': fromDate,
            'endDate': toDate
        }
        NotificationManager.success(
            '',
            'Please wait. It will takes 1-2 mintues for downloading.',
            3000,
            null,
            null,
            'success'
        );      
        AxiosAPI({
            method: 'post',
            url: `${postAPI_Voucher_Send_Statement}`,
            data,
        })
            .then((res) => {
                // setIsLoading(false);
                if (res.data.status != "") {
                    // console.log(res.data, res.data.status.substring(res.data.status.lastIndexOf("/") + 1,
                    //     res.data.status.length));
                    const element = document.createElement("a");
                    const file = res.data.status;
                    element.href = (file);
                    element.target = "_blank";
                    element.download = res.data.status.substring(res.data.status.lastIndexOf("/") + 1,
                        res.data.status.length);
                    document.body.appendChild(element);
                    element.click();
                }
                else {

                }

                // })
                // .catch((res) => {
                //     NotificationManager.danger(
                //         '',
                //         'Something went wrong. Please try again after some time.',
                //         3000,
                //         null,
                //         null,
                //         'success'
                //     );
            });

    }
    return (


        
        <Fragment>
               <Row className="col-md-12">
                {(
                    <Fragment>
                        <Colxx xxs="12" md="2" className="mb-2">
                        <FormGroup><Label>Start Date</Label>
                            <DatePicker
                                selected={startDate}
                                onChange={(e)=>setStartDate(e)}
                                placeholderText="Start Date"
                                dateFormat="DD/MM/YYYY"
                            />
                            </FormGroup>
                        </Colxx>
                        <Colxx xxs="12" md="2" className="mb-2">
                         <FormGroup><Label>End Date</Label>
                            <DatePicker
                                selected={endDate}
                                onChange={(e)=>setEndDate(e)}
                                placeholderText="End Date"
                                dateFormat="DD/MM/YYYY"
                            />
                             </FormGroup>
                        </Colxx>
                        <Colxx xxs="12" md="1" className="mb-2 mt-4">
                            <Button
                                color="primary"                            
                                onClick={() => { handleSubmit(); }}
                            >
                               Submit
                            </Button>
                        </Colxx>
                    </Fragment>
                )
                }

            </Row>
            <div className="statement mt-4">
                <Row className="mb-3">
                    <Colxx xxs="12" className="text-right">
                        <Button className="statement-button" onClick={handleDownload}>
                            <FontAwesomeIcon icon={faFilePdf} /> Print PDF
                        </Button>
                        {statement.statementList !== undefined && statement.statementList.length > 0 ?
                            <Button className="statement-button ml-2">
                                <CSVLink {...csvReport} ><span style={{ color: 'white' }}>Download CSV</span></CSVLink>
                            </Button> :
                            <Button className="statement-button ml-2">
                                <span style={{ color: 'white' }}>Download CSV</span>
                            </Button>
                        }
                    </Colxx>
                </Row>
                <Row className="mb-3 ml-1">
                    <Col md="6">
                        <p className="mb-2 statement-info">From Payer:</p>
                        <p className="mb-2 statement-info">Myma Digital Limited, trading as <b>aiva</b></p>
                        <p className="mb-2 statement-info">8 Whakatomo Place</p>
                        <p className="mb-2 statement-info">Havelock North</p>
                        <p className="mb-2 statement-info">New Zealand 4130</p>
                    </Col>
                    <Col md="6">
                        <p className="mb-2 statement-info">Paid To:</p>
                        <p className="mb-2 statement-info">Party: {property !== '' ? property.name : ""} </p>
                        <p className="mb-2 statement-info">Bank Account: {(integrations.length > 0 && integrations[0].channelDetails != null && integrations[0].channelDetails.bankAccountDetails !== undefined )? integrations[0].channelDetails.bankAccountDetails.accountNumber : ""}</p>
                    </Col>
                </Row>

                <div className="statement-list">

                    {statement.statementList !== undefined && statement.statementList.length > 0 && (
                        <Fragment>
                            <div className="d-flex justify-content-center text-center">
                                <div className="justify-content-center statement-item statement-item-large statement-header">

                                    <b>Voucher Name</b>
                                </div>
                                {statement.header !== undefined && statement.header.isOwnerNameVisible == true && <div className="justify-content-center statement-item statement-header">
                                    <b>Voucher Owner</b>
                                </div>}
                                {statement.header !== undefined && statement.header.isSellingPartyNameVisible == true && <div className="justify-content-center statement-item statement-header">
                                    <b>Selling Partner</b>
                                </div>}
                                <div className="justify-content-center statement-item statement-header">
                                    <b>Order Number</b>
                                </div>
                                <div className="justify-content-center statement-item statement-header">
                                    <b>Voucher Number</b>
                                </div>
                                <div className="justify-content-center statement-item statement-item-large statement-header">

                                    <b>Customer</b>
                                </div>
                                <div className="justify-content-center statement-item statement-header">
                                    <b> Voucher Status</b>
                                </div>
                                <div className="justify-content-center statement-item statement-header">
                                    <b> Reporting Tags</b>
                                </div>                        
                                <div className="justify-content-center statement-item-small statement-header">
                                    <b> Voucher Sale Date</b>
                                </div>
                                <div className="justify-content-center statement-item-small statement-header">
                                    <b>Sale Amount</b>
                                </div>
                                {statement.header !== undefined && statement.header.isAivaFeeVisible == true && <div className="justify-content-center statement-item-small statement-header">
                                    <b><span style={{ textTransform: 'lowercase' }}>aiva</span> commission</b>
                                </div>}
                                {statement.header !== undefined && statement.header.isThirdPartyVisible == true && <div className="justify-content-center statement-item-small statement-header">
                                    <b>3rd party commission</b>
                                </div>}
                                <div className="justify-content-center statement-item statement-header">
                                    <b>Settlement Date</b>
                                </div>
                                <div className="justify-content-center statement-item statement-header">
                                    <b>Net Amount</b>
                                </div>
                            </div>
                        </Fragment>

                    )}


                    {statement.statementList !== undefined && statement.statementList.length > 0 && statement.statementList.map((m, index) => (
                        <Fragment key={index}>
                            <div className="d-flex justify-content-center text-center ">
                                <div className="justify-content-center statement-item statement-item-large">

                                    {m.voucherName}
                                </div>
                                {statement.header !== undefined && statement.header.isOwnerNameVisible == true && <div className="justify-content-center statement-item">
                                    {m.ownerName}
                                </div>}
                                {statement.header !== undefined && statement.header.isSellingPartyNameVisible == true && <div className="justify-content-center statement-item">
                                    {m.sellingPartyName}
                                </div>}
                                <div className="justify-content-center statement-item">
                                    {m.orderNumber}
                                </div>
                                <div className="justify-content-center statement-item">
                                    {m.voucherNumber}
                                </div>
                                <div className="justify-content-center statement-item statement-item-large">

                                    {m.email}
                                </div>
                                <div className="justify-content-center statement-item">
                                    {m.voucherStatus}
                                </div>
                                <div className="justify-content-center statement-item">
                                    {m.reportingTags}
                                </div>
                                <div className="justify-content-center statement-item-small">
                                    {moment(m.orderDate).format('YYYY-MM-DD')}
                                </div>
                                <div className="justify-content-center statement-item-small">
                                    ${m.discountedPrice}
                                </div>
                                {statement.header !== undefined && statement.header.isAivaFeeVisible == true &&
                                    <div className="justify-content-center statement-item-small">
                                        {parseFloat((m.aivaFee * 100) / m.discountedPrice).toFixed(2)}%
                                    </div>}
                                {statement.header !== undefined && statement.header.isThirdPartyVisible == true &&
                                    <div className="justify-content-center statement-item-small">
                                        {parseFloat((m.thirdPartyFee * 100) / m.discountedPrice).toFixed(2)}%
                                    </div>}
                                <div className="justify-content-center statement-item">
                                    {m.settlementDate === "" ? "" : moment(m.settlementDate).format('YYYY-MM-DD')}
                                </div>
                                <div className="justify-content-center statement-item">
                                    ${(m.redeem == 1 || m.redeem == 3) ? "0.00" : m.transferedAmount}
                                </div>
                            </div>
                        </Fragment>
                    ))}

                    {statement.statementList === undefined && isLoading === true &&
                        <div className="mx-auto my-auto">
                            <Spinner style={{ color: '#EF4A81' }} className="mb-1" />
                        </div>}

                </div>

                {statement.footer !== undefined &&
                    <Fragment>
                        <Row className="mt-2 mb-2">
                            <Col md="11" className=" text-right statement-item-footer">
                                <b>TOTAL SALES : </b>
                            </Col>
                            <Col md="1" className=" text-left statement-item-value">
                                <span className="ml-1">{"$" + parseFloat(statement.footer.totalSales).toFixed(2)}</span>
                            </Col>
                        </Row>
                        {statement.footer !== undefined && statement.footer.isAivaVisible == true && <Row className="mb-2 text-right">
                            <Col md="11" className=" text-right statement-item-footer">
                                <b>LESS AIVA FEE : </b>
                            </Col>
                            <Col md="1" className=" text-left statement-item-value">
                                <span className="ml-1">${parseFloat(statement.footer.aivaFee).toFixed(2)}</span>
                            </Col>
                        </Row>}
                        {statement.footer !== undefined && statement.footer.isThirdPartyVisible == true && <Row className="mb-2 text-right">
                            <Col md="11" className=" text-right statement-item-footer">
                                <b>LESS 3rd PARTY SHARE : </b>
                            </Col>
                            <Col md="1" className=" text-left statement-item-value">
                                <span className="ml-1">{"$" + parseFloat(statement.footer.thirdPartyFee).toFixed(2)}</span>
                            </Col>
                        </Row>}

                        <Row className="mt-2 mb-2">
                            <Col md="11" className=" text-right statement-item-footer">
                                <b>LESS REFUNDS & VOIDS : </b>
                            </Col>
                            <Col md="1" className=" text-left statement-item-value">
                                <span className="ml-1">{"$" + parseFloat(statement.footer.refunds).toFixed(2)}</span>
                            </Col>
                        </Row>
                        <Row className="text-right statement-footer-bottom">
                            <Col md="11" className=" text-right statement-item-footer">
                                <b>NET PAID ({statement.footer.currency}) : </b>
                            </Col>
                            <Col md="1" className=" text-left statement-item-value">
                                <span className="ml-1"><b>{"$" + parseFloat(statement.footer.netPaid).toFixed(2)}</b></span>
                            </Col>
                        </Row>
                    </Fragment>
                }
            </div>
        </Fragment>

    );
}


const mapStateToProps = ({ settings }) => {
    const { propertyId } = settings;
    return {
        propertyId,
    };
};
export default injectIntl(connect(mapStateToProps)(Statement));

